// Cat component renderer for Cat Premium Themes
// Creates the cat HTML structure and handles cursor-following eyes

export const renderCat = () => {
  // Check if cat theme is active
  const currentTheme = document.documentElement.getAttribute('data-theme');
  if (currentTheme !== 'cat-premium' && currentTheme !== 'cat-premium-dark') {
    return;
  }

  // Check if cat already exists
  if (document.querySelector('.cat-container')) {
    return;
  }

  // Create cat HTML structure
  const catHTML = `
    <div class="cat-container">
      <div class="cat">
        <div class="ear ear--left"></div>
        <div class="ear ear--right"></div>
        <div class="face">
          <div class="eye eye--left">
            <div class="eye-pupil"></div>
          </div>
          <div class="eye eye--right">
            <div class="eye-pupil"></div>
          </div>
          <div class="muzzle"></div>
        </div>
      </div>
    </div>
  `;

  // Insert cat into body
  const catContainer = document.createElement('div');
  catContainer.innerHTML = catHTML;
  document.body.appendChild(catContainer.firstElementChild);
};

export const removeCat = () => {
  const catContainer = document.querySelector('.cat-container');
  if (catContainer) {
    catContainer.remove();
  }
};

export const initCatEyeTracker = () => {
  const currentTheme = document.documentElement.getAttribute('data-theme');
  
  if (currentTheme !== 'cat-premium' && currentTheme !== 'cat-premium-dark') {
    return;
  }

  // First render the cat
  renderCat();

  // Get pupil elements
  const leftPupil = document.querySelector('.eye--left .eye-pupil');
  const rightPupil = document.querySelector('.eye--right .eye-pupil');

  if (!leftPupil || !rightPupil) {
    console.warn('Cat pupils not found, retrying...');
    setTimeout(() => initCatEyeTracker(), 200);
    return;
  }

  const updateEyePosition = (e) => {
    const currentTheme = document.documentElement.getAttribute('data-theme');
    
    if (currentTheme !== 'cat-premium' && currentTheme !== 'cat-premium-dark') {
      return;
    }

    const mouseX = e.clientX;
    const mouseY = e.clientY;

    // Get cat container position
    const catContainer = document.querySelector('.cat-container');
    if (!catContainer) return;

    const catRect = catContainer.getBoundingClientRect();
    
    // Calculate eye centers (approximate positions within the cat)
    const leftEyeX = catRect.left + (catRect.width * 0.30);
    const leftEyeY = catRect.top + (catRect.height * 0.50);
    
    const rightEyeX = catRect.left + (catRect.width * 0.70);
    const rightEyeY = catRect.top + (catRect.height * 0.50);

    // Calculate angles
    const leftAngle = Math.atan2(mouseY - leftEyeY, mouseX - leftEyeX);
    const rightAngle = Math.atan2(mouseY - rightEyeY, mouseX - rightEyeX);

    // Calculate distances (limited movement)
    const maxDistance = 8; // Maximum pupil movement in pixels
    const leftDistance = Math.min(maxDistance, Math.hypot(mouseX - leftEyeX, mouseY - leftEyeY) / 80);
    const rightDistance = Math.min(maxDistance, Math.hypot(mouseX - rightEyeX, mouseY - rightEyeY) / 80);

    // Calculate pupil positions
    const leftX = Math.cos(leftAngle) * leftDistance;
    const leftY = Math.sin(leftAngle) * leftDistance;
    
    const rightX = Math.cos(rightAngle) * rightDistance;
    const rightY = Math.sin(rightAngle) * rightDistance;

    // Apply transforms
    if (leftPupil) {
      leftPupil.style.transform = `translate(${leftX * 10}%, ${leftY * 10}%)`;
    }
    if (rightPupil) {
      rightPupil.style.transform = `translate(${rightX * 10}%, ${rightY * 10}%)`;
    }
  };

  // Throttle for performance
  let ticking = false;
  const handleMouseMove = (e) => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateEyePosition(e);
        ticking = false;
      });
      ticking = true;
    }
  };

  document.addEventListener('mousemove', handleMouseMove);

  // Return cleanup function
  return () => {
    document.removeEventListener('mousemove', handleMouseMove);
    removeCat();
  };
};

export const cleanupCatEyeTracker = () => {
  removeCat();
};
